import { ActivityEntityName, TimesheetEntry } from '@jms/model/entities';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ContactMergeData, ContactMergeSchema } from './contact.merge.data';
import { DurationUtility } from '@jms/model/utilities';

@MergeSchema({
    entity: ActivityEntityName.TimeSheet,
    name: 'TimesheetMergeDataSchema',
})
export class TimesheetMergeData {
    @MergeField()
    date: Date;

    @MergeField({
        nestedFieldSchema: ContactMergeSchema
    })
    resource: ContactMergeData;

    @MergeField()
    notes: string;

    @MergeField()
    workRole: string;

    @MergeField()
    workType: string;

    @MergeField()
    status: string;

    @MergeField()
    start: Date;

    @MergeField()
    end: Date;

    @MergeField()
    duration: string;

    @MergeField()
    billableHours: string;

    @MergeField()
    billableStatus: string;

    @MergeField()
    hourlyCostRateExTax: number;

    @MergeField()
    hourlySellRateExTax: number;

    @MergeField()
    totalCostExTax: number;

    @MergeField()
    totalSellExTax: number;
}

export const TimesheetMergeDataSchema = getSchema(TimesheetMergeData);

@MergeSchema({
    entity: ActivityEntityName.TimeSheet
})
export class TimesheetArrayMergeData {
    @MergeField({
        arraySchemaName: "TimesheetMergeDataSchema"
    })
    timesheets: TimesheetMergeData[];
}

export const TimesheetArrayMergeDataSchema = getSchema(TimesheetArrayMergeData);


export const transformTimesheetEntryToMergeData = (entry: TimesheetEntry, resource: ContactMergeData): TimesheetMergeData => {

    return {
        date: entry.date,
        resource: resource,
        notes: entry.notes,
        workRole: entry.workRole?.name,
        workType: entry.workType?.name,
        status: entry.status,
        start: entry.start?.time,
        end: entry.end?.time,
        duration: DurationUtility.stringify(entry.duration?.duration),
        billableHours: DurationUtility.stringify(entry.duration?.customBillable),
        billableStatus: entry.billable,
        hourlyCostRateExTax: entry.rate?.cost ?? 0,
        hourlySellRateExTax: entry.rate?.sell ?? 0,
        totalCostExTax: entry.total?.cost ?? 0,
        totalSellExTax: entry.total?.amount ?? 0
    };
}
